import { useSearchParams } from "react-router-dom";
import RoomSelect from "./roomSelect";
import RoomStatus from "./roomStatus";

const RoomWrapper = () => {
  const [params] = useSearchParams();
  const room = params.get("room");

  return room ? <RoomStatus /> : <RoomSelect />;
};

export default RoomWrapper;